import FinancialDocumentsTable from 'src/features/financialDocuments/components/tables/FinancialDocumentsTable';
import useHasPermissions from 'src/utils/useHasPermissions';
import { PERMISSION } from 'src/features/auth/types';

/**
 * The accounting range dashboard shows a single table, so it renders it directly. A one-entry tab
 * row offers a control that can never change anything.
 */
const AccountingRangeDashboardTables = () => {
    const permissionAccessFinancialDocs = useHasPermissions([PERMISSION.ACCESS_FINANCIAL_DOCUMENTS]);

    if (!permissionAccessFinancialDocs) return null;

    return (
        <div className="grid flex-3 grid-cols-1 pr-8">
            <FinancialDocumentsTable />
        </div>
    );
};

export default AccountingRangeDashboardTables;
